import fieldDataClient from "../../api/digitalTwin/fieldDataClient";
import { call, put, takeLatest } from "redux-saga/effects";
import { fetchPlantDigitalTwinStart, fetchPlantDigitalTwinSuccess, fetchPlantDigitalTwinFailure } from "../../store/features/digitalTwin/plantDigitalTwinSlice";

const URL = "/digital_twins/";

const getPlantDigitalTwin = async (plant_id) => {
  try {
    const response = await fieldDataClient.get(`${URL}?plant_id=${plant_id}`);
    console.log("here", response);
    return response.data;
  } catch (error) {
    console.log("here error", error);
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchPlantDigitalTwinSaga(action) {
  try {
    const { plant_id } = action.payload;
    const plantDigitalTwinData = yield call(getPlantDigitalTwin, plant_id);
    yield put(fetchPlantDigitalTwinSuccess(plantDigitalTwinData));
  } catch (error) {
    yield put(fetchPlantDigitalTwinFailure(error.message));
  }
}

export default function* plantDigitalTwinSaga() {
  yield takeLatest(fetchPlantDigitalTwinStart.type, fetchPlantDigitalTwinSaga);
}
